import React from "react";
import helper from "../../../../helper/helper";
import typo from '../../../../constants/dictionaries'

const columns = ({handleShowDetail} = {}) =>
  [
    {
      title: "#",
      dataIndex: "stt",
      width: "45px",
      align: 'center',
      fixed: 'left',
    },
    {
      title: "Số giấy phép",
      dataIndex: "soVanBan",
      defaultSortOrder: "descend",
      fixed: 'left',
      width: "120px",
      render: (value, row) => <a onClick={() => handleShowDetail(row)}>{value}</a>
    },
    {
      title: typo.cscore_license_signed_person,
      dataIndex: "nguoiKy",
      width: "150px",
    },
    {
      title: typo.cscore_license_available_date,
      dataIndex: "ngayBDHieuLuc",
      width: "120px",
      render: (value, row) => (helper.formatTableDate(row.ngayBDHieuLuc)),
    },
    {
      title: typo.cscore_license_available_end_date,
      dataIndex: "ngayKTHieuLuc",
      width: "120px",
      render: (value, row) => (helper.formatTableDate(row.ngayKTHieuLuc)),
    },
    {
      title: "Thời hạn",
      dataIndex: "thoiHan",
      width: "120px",
    },
  ].map(col => ({ ...col}));

export default columns;
